import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Link from 'next-translate-routes/link';

import { useMediaQuery } from '@hooks/useMediaQuery';
import { xSmallScreen } from '@styles/constants';

import * as S from './styles';
import { IBreadcrumb, IBreadcrumbsProps } from './types';
import { BreadcrumbList } from './BreadcrumbList';

const getBackLink = (breadcrumbs: IBreadcrumb[]) =>
  breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2].link : '/';

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({
  breadcrumbs,
  useMediaQueries = true,
  showHomeLink = true,
}) => {
  const [isSmallScreen] = useMediaQuery(`(max-width: ${xSmallScreen}px)`);

  if (!useMediaQueries) {
    return (
      <BreadcrumbList breadcrumbs={breadcrumbs} showHomeLink={showHomeLink} />
    );
  }

  return isSmallScreen ? (
    <BreadcrumbList breadcrumbs={breadcrumbs} showHomeLink={showHomeLink} />
  ) : (
    <S.Breadcrumbs>
      <Link href={getBackLink(breadcrumbs)}>
        <a>
          <FormattedMessage defaultMessage="Back" id="cyR7Kh" />
        </a>
      </Link>
    </S.Breadcrumbs>
  );
};
